import React, { createContext, useContext, useState } from "react";
import { LexicalEditor } from "lexical";

interface NotesEditorContextType {
  editor: LexicalEditor | null;
  setEditor: (editor: LexicalEditor | null) => void;
}

const NotesEditorContext = createContext<NotesEditorContextType | undefined>(undefined);

export const NotesEditorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [editor, setEditor] = useState<LexicalEditor | null>(null);

  return (
    <NotesEditorContext.Provider value={{ editor, setEditor }}>
      {children}
    </NotesEditorContext.Provider>
  );
};

export const useNotesEditor = () => {
  const context = useContext(NotesEditorContext);
  if (!context) {
    throw new Error("useNotesEditor must be used within NotesEditorProvider");
  }
  return context;
};
